import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Typography } from '../../../typography/Typography.mjs';
import { dayText } from '../../dayOverride.vanilla.mjs';

const DayText = forwardRef(
  ({ dayOfMonth, className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Typography,
      {
        ref,
        className: classNames(dayText, className),
        ...props,
        children: dayOfMonth
      }
    );
  }
);

export { DayText };
//# sourceMappingURL=day.mjs.map
